import { render, staticRenderFns } from "./VInputRadio.vue?vue&type=template&id=f7490180&"
import script from "./VInputRadio.vue?vue&type=script&lang=ts&"
export * from "./VInputRadio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports